import { StyledTag } from './sponsoredTag.style'

export const SponsoredTag = () => {
  return (
    <StyledTag>
      <span>Patrocinado</span>
    </StyledTag>
  )
}
